import React, {Children, isValidElement} from 'react';
import './DialogStack.less';
import {CSSTransition, TransitionGroup} from "react-transition-group";
import isArray from 'lodash/isArray';

export const DialogStack = ({children}) => {
	const childrenCount = Children.count(children);
	let selectedDialog = null;

	if (childrenCount > 1) {
		selectedDialog = children.filter(child => isValidElement(child))[0];
	} else if (childrenCount === 1) {
		selectedDialog = isArray(children) ? children[0] : children;
	}

	return <div className="dialog-stack">
		<TransitionGroup>
			<CSSTransition
				key={isValidElement(selectedDialog) ? selectedDialog.key : 'empty'}
				classNames="dialog"
				timeout={300}
			>
				{isValidElement(selectedDialog) ? selectedDialog : <div></div>}
			</CSSTransition>
		</TransitionGroup>
	</div>
}
